import axiosClient from "./axiosClient";

export const trackOrder = async (orderId, phone) => {
  const response = await axiosClient.get(`/orders/${orderId}/track`, {
    params: {
      phone: phone,
    },
  });

  return response.data;
};
